<template>
    <div style="overflow:hidden; position: relative;">
        <div style="position: absolute; z-index:100;left:0px; width: 100%; height: 30px; top:-100px; text-align:center;" :style="{ top: refreshMarkTop, opacity: refreshMarkOpacity }" ref="refreshMark">
            <img :src="require('@/assets/soccer_ball_loading.png')" style="width:60px; height:60px;-webkit-animation-duration: 4s; animation-duration: 4s;  animation-iteration-count: infinite; -webkit-animation-iteration-count: infinite; pointer-events: none;" :style="{ animationName: curAnimation ? curAnimation : '', webkitAnimationName: curAnimation ? curAnimation : '' }">
        </div>
        <!--<div style="position: absolute; width: 100%; height: 30px; background-color: pink; top:100px" >{{logTxt}}</div>-->
        <div ref="scrollWrap" class="hide_scroll" style="overflow:auto; height:100%; " @scroll="scroll($event)" @touchstart="touchStart($event)" @touchmove="touchMove($event)" @touchend="touchEnd($event)">
            <div :style="{ overflowX: isNeedXHidden ? 'hidden' : '' }" ref="contentsWrap">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { SOCCER_HOW_TYPE } from '../../Constants';

export default {
    name: "InfinityScroll",
    props: {
        isEnableNextPageHandle: {
            type: Boolean,
            default: true
        },
        handleNextPage: {
            type: Function,
            default: () => { }
        },
        refreshAction: {
            type: Function,
            default: null
        },
        soccerHowType: {
            type: String,
            default: null,
        },
        changeDetectedScrollType: {
            type: Function,
            default: () => { }
        },
        resetDetectedScrollType: {
            type: Function,
            default: () => { }
        },
        disableScroll: {
            type: Boolean,
            default: false,
        },
        detectScroll: {
            type: Function,
            default: () => { }
        },
        isNeedXHidden: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            touchStartY: 0,
            isScrollTop: false,
            scrollTopZeroY: 0,
            refreshMark: null,
            logTxt: '',
            refreshMarkTop: '-30px',
            refreshMarkOpacity: 0,
            isShowAnimation: false,
            curAnimation: '',
            SOCCER_HOW_TYPE: SOCCER_HOW_TYPE,
            timeoutId: null
        }
    },
    methods: {
        scroll(e) {
            const target = e.currentTarget;
            this.__conveyScrollTop(target.scrollTop)
            if (target.scrollTop > 1) {
                this.changeDetectedScrollType()
            } else if (target.scrollTop < 1) {
                this.resetDetectedScrollType()
            }
            if (target.scrollTop > (this.$refs.contentsWrap.offsetHeight - (target.offsetHeight + 100))) {
                if (this.isEnableNextPageHandle) {
                    if (!this.disableScroll) {
                        this.handleNextPage();
                    }
                }
            }

            this.detectScroll(e);
        },
        touchStart(e) {
            if (!this.refreshAction) return;
            this.touchStartY = e.touches[0].pageY;
        },
        touchMove(e) {
            if (!this.refreshAction) return;
            const curClientY = e.touches[0].pageY;
            // this.logTxt = e.currentTarget.scrollTop;
            //아래방향
            if (curClientY - this.touchStartY > 0) {
                if (e.currentTarget.scrollTop <= 0 && !this.isScrollTop) {
                    this.scrollTopZeroY = curClientY;
                    this.isScrollTop = true;
                    // e.currentTarget.style.overflow = 'hidden';
                } else if (this.isScrollTop) {
                    const diff = curClientY - this.scrollTopZeroY;
                    // this.degree = diff;
                    this.refreshMarkTop = '30px';
                    this.refreshMarkOpacity = diff / 150;
                    if (this.refreshMarkOpacity > 1) {
                        this.isShowAnimation = true;
                    } else {
                        this.isShowAnimation = false;
                    }
                    // this.refreshMark.style.transform = 'translateY(' + parseInt((diff) / 2) + 'px)';
                }
            }
        },
        touchEnd(e) {
            if (!this.refreshAction) return;
            this.scrollTopZeroY = 0;
            this.isScrollTop = false;
            this.refreshMark.style.transform = 'unset';
            e.currentTarget.style.overflow = 'auto';

            if (this.isShowAnimation) {
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId); // 기존 타이머 제거
                }

                this.isRefreshComplete = false;
                this.curAnimation = 'ani_rotate';

                this.timeoutId = setTimeout(async () => {
                    this.curAnimation = 'ani_twinkle';
                    await this.refreshAction();
                    this.curAnimation = '';
                    this.refreshMarkTop = '-100px';
                    this.isCompleteRefresh = false;
                    this.timeoutId = null;
                }, 2000);
            } else {
                this.curAnimation = '';
                this.refreshMarkTop = '-100px';
            }

            this.isShowAnimation = false;
        },
        __conveyScrollTop(scrollTop) {
            this.$emit('convey-scroll-top', scrollTop)
        }
    },
    mounted() {
        this.refreshMark = this.$refs.refreshMark;
    },
}
</script>

<style>
@keyframes ani_rotate {
    0% {}

    10% {
        transform: rotate(45deg);
        opacity: 0;
    }

    20% {
        transform: rotate(-45deg);
        opacity: 1;
    }

    45% {
        opacity: 0.5;
    }

    50% {
        opacity: 1.0;
        transform: rotate(360deg);
    }

    100% {
        opacity: 1.0;
        transform: rotate(360deg);
    }
}

@keyframes ani_twinkle {
    0% {
        opacity: 1;
    }

    20% {
        opacity: 0;
    }

    40% {
        opacity: 1;
    }

    60% {
        opacity: 0;
    }

    80% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }

}
</style>